import React, { useState } from 'react';
import './Navbar.css';
import { HiMenu, HiX } from 'react-icons/hi';

export function Navbar({ setActiveSection, scrollToSection }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo">Portfolio</div>

      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <HiX /> : <HiMenu />}
      </div>

      <ul className={`navbar-links ${isOpen ? 'active' : ''}`}>
        <li><a href="#home" onClick={() => setActiveSection('home')}>Home</a></li>
        <li><a href="#projects" onClick={() => setActiveSection('projects')}>Projects</a></li>
        <li><a href="#journey" onClick={() => setActiveSection('JourneySection')}>Journey</a></li>
        <li><a href="#certificates" onClick={() => setActiveSection('CertificateSection')}>Certificates</a></li>
        <li><a href="#about" onClick={() => setActiveSection('AboutSection')}>About Me</a></li>
        <li><a href="#blogs" onClick={() => setActiveSection('BlogSection')}>Blogs</a></li>
        <li><a href="#contact" onClick={(e) => {
          e.preventDefault();
          scrollToSection();
        }}>Contact</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
